import { render, staticRenderFns } from "./ExemptionReceipt.vue?vue&type=template&id=06f8aff8"
import script from "./ExemptionReceipt.vue?vue&type=script&lang=js"
export * from "./ExemptionReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports